import {useRouter} from "next/router";
import localized from "../../locale/locales";
import SvgSolutionBg from "../../svg/SvgSolutionBg";
import Container from "../Container";
import Title from "../Title";
import ConceptCol from "../ConceptCol";
import imageBioStrength from "../../public/img/biostrength.jpg";
import imagePersonalTraining from "../../public/img/personal_training.jpg";
import Fadeout from "../Fadeout";

export default function SectionSolution() {
    const {locale} = useRouter();
    const lang = localized[locale].gym.solutions;

    return (
        <div className="relative">
            <SvgSolutionBg
                className="hidden lg:block absolute bottom-0 left-1/2 -translate-x-1/2 w-full text-white max-w-[1600px] pointer-events-none"
            />
            <div
                className="hidden lg:block absolute w-full h-full top-0 left-1/2 -translate-x-1/2 max-w-[1600px] pointer-events-none">
                <Fadeout direction="right" color="black" className="w-[100px]"/>
                <Fadeout direction="left" color="black" className="w-[100px]"/>
            </div>

            <div className="pt-28 md:pt-20 pb-36 md:pb-20 md:bg-black">
                <Container className="md:text-white flex flex-col gap-12 md:gap-20">
                    <header>
                        <Title className="text-center">{lang.title}</Title>
                    </header>
                </Container>
            </div>

            <div className="bg-black pb-20 md:pb-32">
                <Container>
                    <div
                        className="relative flex flex-col md:flex-row items-center md:items-stretch justify-center gap-20 text-white">
                        <div className="-mt-20 md:mt-0">
                            <ConceptCol image={imageBioStrength}
                                        imageAlt={lang.bioCircuit.imageAlt}
                                        title={lang.bioCircuit.title}
                                        body={lang.bioCircuit.body}
                                        cta={{
                                            label: lang.bioCircuit.cta,
                                            theme: 'secondary',
                                            href: '/biostrength'
                                        }}
                            />
                        </div>

                        <div>
                            <ConceptCol image={imagePersonalTraining}
                                        imageAlt={lang.personalTraining.imageAlt}
                                        title={lang.personalTraining.title}
                                        body={lang.personalTraining.body}
                                        cta={{
                                            label: lang.personalTraining.cta,
                                            theme: 'secondary',
                                            href: '/trainers'
                                        }}
                            />
                        </div>

                    </div>
                </Container>
            </div>

        </div>
    )
}